<style lang="css">
.chainId-dropdown-acc {
  width: 440px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}

.chainId-dropdown-acc .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.chainId-dropdown-acc .ivu-input {
  border-radius: 0;
}

.pulldown .vxe-pulldown--content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<template>
  <div>
    <vxe-pulldown ref="sellerDown" transfer class="pulldown">
      <template>
        <div :title="row[field]" class="link-text" @click="focusEvent('sellerDown')" target="_black"
             :style="isEdit ? 'cursor: pointer;display: inline-block;width: 100%;text-align: center;color:#2d8cf0;' :'cursor: pointer;display: inline-block;width: 100%;text-align: center;color:#606266;'">
          {{
            row[field] == null ||
            row[field] == "" ? placeholder : row[field]
          }}
        </div>
      </template>
      <template v-slot:dropdown>
        <div class="chainId-dropdown-acc">
          <Input search suffix="ios-search" v-model="name" placeholder @on-search="search" style="width: 200px"/>
          <vxe-grid
              border="none"
              highlight-hover-row
              auto-resize
              height="auto"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              @cell-click="cellClick"
              @page-change="pageChange"
              :pager-config="tablePage"
          ></vxe-grid>
        </div>
      </template>
    </vxe-pulldown>
  </div>
</template>


<script>
import $api from "@/apiProvider";
import {isEmpty} from "@/utils/util";

export default {
  name: "PlatformCorp",
  props: {
    row: {
      type: Object,
      default: null,
    },
    field: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    rowIndex: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      tableData: [],
      columns: [{field: "realName", title: "姓名"}, {field: "regisiterNum"}],
      name: null, // 承运人订单搜索
      loading: false,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        // size: "mini",
      },
    };
  },
  methods: {
    pageChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getList();
    },
    focusEvent(name) {
      if (!this.isEdit) return;
      let refs = this.$refs[name];
      refs.showPanel();
      this.name = null;
      this.tablePage = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      };
      this.getList();
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getList();
    },
    async getList() {
      let params = {
        userType: 1,
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize,
        username: this.name,
        isTaxSelect: 1,
      };
      if (isEmpty(this.tableData)) {
        this.loading = true;
      }
      let res = await $api.gcdUser.request("queryUserListWithoutPermission", params);
      this.loading = false;
      if (res.status === 1) {
        this.tableData = res.data.rows;
        this.tablePage.total = res.data.total;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cellClick({row}) {
      this.$refs.sellerDown.hidePanel();
      this.$emit("select", row);
    },
  },
};
</script>